export default __webpack_public_path__ + "static/media/FE DE ERRATAS.fdfb31d0.pdf";